

// Autogenerated 2023-05-18 09:36:21.434436
// gen_js_enum.py proto/proto/investment_accounts.proto src/lib/proto/investment_accounts.js

const InvestmentAccountType = {
  ACCOUNT_TYPE_UNDEFINED: { value: 0, id: "ACCOUNT_TYPE_UNDEFINED" },
  individual: { value: 1, id: "individual", label: "Individual" },
  joint: { value: 2, id: "joint", label: "Joint" },
  ira: { value: 3, id: "ira", label: "IRA" },
  rollover_ira: { value: 4, id: "rollover_ira", label: "Rollover IRA" },
  roth_ira: { value: 5, id: "roth_ira", label: "Roth IRA" },
  sepp_ira: { value: 6, id: "sepp_ira", label: "SEPP IRA" },
  ugma_utma: { value: 7, id: "ugma_utma", label: "UGMA" },
  a_529: { value: 8, id: "a_529", label: "529" },
  corporate: { value: 9, id: "corporate", label: "Corporate" },
  partnership: { value: 10, id: "partnership", label: "Partnership" },
  simple_ira: { value: 11, id: "simple_ira", label: "SIMPLE IRA" },
  custodial_ira: { value: 12, id: "custodial_ira", label: "Custodial IRA" },
};

const is_ira = account_type => {
  return account_type === "ira" || account_type === "roth_ira" || account_type === "rollover_ira"
    || account_type === "sepp_ira" || account_type === "simple_ira"
    || account_type === "custodial_ira";
}

export { InvestmentAccountType, is_ira };
